"use client";

import { Select } from "@/components/ui/select";
import { DURATION_LABELS, DURATION_OPTIONS } from "@/features/search/lib/duration-options";
import { cn } from "@/lib/utils";

export function FilterDurationInput({
  value,
  onChange,
  placeholder,
}: {
  value: number | undefined;
  onChange: (months: number | undefined) => void;
  placeholder: string;
}) {
  const displayLabel = value != null ? (DURATION_LABELS[value] ?? `${value} months`) : placeholder;

  return (
    <Select>
      <Select.Trigger className="w-fit" size="xs" variant="filter">
        {displayLabel}
        <Select.Icon className="ml-auto" />
      </Select.Trigger>
      <Select.Content className="w-32">
        <Select.List>
          {DURATION_OPTIONS.map((opt) => {
            const isSelected = opt.months === value;
            const label = opt.label.replace("No Minimum", placeholder);

            return (
              <Select.Item
                key={opt.label}
                
                selected={isSelected}
                onSelect={() => onChange(opt.months)}
              >
                <span
                  className={cn(
                    "flex-1 text-sm text-left",
                    isSelected ? "text-ai" : "text-foreground/75",
                  )}
                >
                  {label}
                </span>
                {isSelected && <Select.ItemCheck />}
              </Select.Item>
            );
          })}
        </Select.List>
      </Select.Content>
    </Select>
  );
}
